import { CheckInsHeader } from "../components/checkIns/checkInsHeader";
import { SideMenu } from "../components/sideMenu/sideMenu";
import { CheckInsList } from "../components/checkIns/checkInsList";
import { useSearchParams } from "react-router-dom";
import { useAtom, useAtomValue } from "jotai";
import { currentArtistAtom } from "../atoms/artistAtom";
import { useEffect } from "react";
import { StoreKey } from "../models/cacheKey";
import { userAtom } from "../atoms/userAtom";
import { AdminUser } from "../models/adminUser";
import { GetSessionToken } from "../utils/store";

export function CheckIns() {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentArtist = useAtomValue(currentArtistAtom);
  const [user, setUser] = useAtom(userAtom);

  const artist = searchParams.get(StoreKey.queryArtist);
  const page = searchParams.get(StoreKey.queryPage);

  useEffect(() => {
    if (artist === null && currentArtist) {
      searchParams.set(StoreKey.queryArtist, `${currentArtist.id}`);
      setSearchParams(searchParams);
    }
    if (!user) {
      const sessionKey = GetSessionToken();
      if (sessionKey) {
        setUser(new AdminUser(sessionKey));
      }
    }
  }, [artist, currentArtist, user, setUser, searchParams, setSearchParams]);

  return (
    <>
      <div className={"drawer drawer-end h-full"}>
        <input
          id={"main-drawer"}
          type={"checkbox"}
          className={"drawer-toggle"}
        />
        <div className={"drawer-content flex flex-col h-full overflow-hidden"}>
          <CheckInsHeader />
          {artist && (
            <CheckInsList
              artist={artist}
              page={Number(page) || 1}
              className={"pl-3 pr-3 flex-grow overflow-y-auto"}
            />
          )}
        </div>
        <div className={"drawer-side"}>
          <label
            htmlFor={"main-drawer"}
            aria-label={"close sidebar"}
            className={"drawer-overlay"}
          ></label>
          <div
            className={
              "w-3/4 bg-base-200 rounded-l-box flex flex-col min-h-full"
            }
          >
            <SideMenu />
          </div>
        </div>
      </div>
    </>
  );
}
